import classNames from 'classnames';
import './index.less';
import { useEffect, useState, useRef } from 'react';
import { Group } from '@/commons/interface/speccommon/group';
import { ContextMenuFC } from 'tncet-common';
import TnInput from '@/commons/widget/input/tn-input';
import { addGroup, deleteGroup, updateGroup } from '@/api/spec-common/group';
import TnMessage from '@/commons/widget/message';
import { ReactComponent as AddSvg } from "@/commons/icons/panel-icon/add-black.svg";
import { ReactComponent as EditSvg } from "./icons/edit.svg";
import { ReactComponent as ConfirmSvg } from "./icons/confirm.svg";
import { ReactComponent as CancelSvg } from "./icons/cancel.svg";
import { ReactComponent as OpenSvg } from "./icons/open.svg";
import { ReactComponent as CloseSvg } from "./icons/close.svg";
import { ReactComponent as MoveSvg } from "./icons/move.svg";
import { ReactComponent as DownSvg } from "./icons/down.svg";
import { ReactComponent as RightSvg } from "./icons/right.svg";
import { ReactComponent as ManySvg } from "./icons/many.svg";
import genUUID from '@/commons/utils/gen-uuid';
import { useParams } from 'react-router-dom';
import { graphicStore } from '@/commons/store/graphic-store';
import { AddPrimitivesCommand, ModelBase } from 'pytha';
import { GroupType } from 'tnbimbase';
import { showEntity } from '@/commons/utils/show-entity';
import { Tooltip } from 'antd';


interface IProps {
    group: Group
    // hover: boolean
    active: boolean
    onClick: (item: Group) => void
    onDelete: (uuid: string) => void
    onUpdate: (data: Group) => void
    onCreate: (data: Group) => void
    setLoading: (value: boolean) => void
    // makeGroup: (data: Group) => void
    getGenerationUuids: (uuid: string) => string[]
    showAll: () => void
    showOne: (uuid: string) => void
    toggleExpand: () => void
}

export default function GroupItem(props: IProps) {
    const { projectUuid, modelUuid, branchUuid } = useParams();
    const ref = useRef(null);
    const [adding, setAdding] = useState<boolean>(false); // 是否处于编辑状态
    const [editing, setEditing] = useState<boolean>(false); // 是否处于编辑状态
    const [cmOpen, setCmOpen] = useState<boolean>(false); // 是否展开建筑的右键菜单
    const [top, setTop] = useState<number>(); // 右键菜单top
    const [left, setLeft] = useState<number>(); // 右键菜单left
    const [grouping, setGrouping] = useState<boolean>(false); // 是否处于编组状态
    const [opeType, setOpeType] = useState<'add' | 'remove' | null>(null); // 操作类型，向组内添加/剔除图元

    useEffect(() => {
        if (!props.active) {
            setGrouping(false);
        }
    }, [props.active])

    const onRightClick = (e) => {
        setCmOpen(true);
        setLeft(e.clientX);
        setTop(e.clientY);
    }

    const onDelete = () => {
        if (!props.group?.uuid) return;
        let deleteUuid = props.group?.uuid;
        props.setLoading(true);
        deleteGroup(deleteUuid).then(res => {
            if (res.status === 200) {
                TnMessage.success("删除成功");
                props.onDelete(deleteUuid);
            }
        }).catch(err => {
            TnMessage.error("删除失败");
        }).finally(() => {
            props.setLoading(false);
        })
    }


    const onUpdate = (newName: string) => {
        if (!newName) {
            setEditing(false);
            return;
        }
        let newGroup = {
            ...props.group,
            name: newName,
        }
        updateGroup(props.group?.uuid, newGroup).then(res => {
            if (res.status === 200) {
                props.setLoading(true);
                props.onUpdate(newGroup);
                TnMessage.success("编辑成功");
            }
        }).catch(err => {
            TnMessage.error("编辑失败");
        }).finally(() => {
            props.setLoading(false);
            setEditing(false);
        })
    }

    const onCreate = (name: string) => {
        if (!name || name?.trim()?.length === 0) {
            setAdding(false);
            return;
        }
        let uuid = genUUID();
        let group: Group = {
            uuid: uuid,
            name: name,
            projectUuid: projectUuid,
            modelUuid: modelUuid,
            parentUuid: props.group?.uuid,
        }
        props.setLoading(true);
        addGroup(projectUuid, modelUuid, group, uuid, false).then(res => {
            if (res.status === 200) {
                let newBuilding = res.data;
                // group = {
                //     ...group,
                //     id: id,
                // }
                props.onCreate(newBuilding);
                TnMessage.success("添加成功");
            }
        }).catch(err => {
            TnMessage.error("添加失败");
        }).finally(() => {
            props.setLoading(false);
            setAdding(false);
        })
    }

    const startGrouping = (ope: 'add' | 'remove') => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        let editor = graphicStore?.extraContext?.getCurrentViewEditor();
        setGrouping(true);
        if (ope === 'add') {
            TnMessage.info("开始向组内添加图元，点击确定按钮后选中的图元会添加到组");
        } else {
            TnMessage.info("开始剔除组内图元，点击确定按钮后选中的图元从组中移除");
        }
        setOpeType(ope);
        editor.selectControl.resetSelectedEntities();
        // let primitives = editor.getEntities()?.filter(item => item?.group[GroupType.GROUP]?.some(guid => guid === props.group.uuid)) || [];
        // editor.selectControl.forceEntitiesSelected(primitives);
        // editor.listeners.signals.needRender.dispatch('redraw');

    }

    const finishGroup = () => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) {
            setGrouping(false);
            return;
        }
        let editor = graphicStore?.extraContext?.getCurrentViewEditor();
        let selected = editor.selectControl.getSelectedEntityList()?.filter(item => item.isSelected);
        let modifyPris = [];
        selected?.forEach(model => {
            let entity = editor.entityDict[model.uuid];
            if (opeType === 'add') {
                if (!entity?.group) {
                    entity.group = {};
                }
                let oldArr = entity.group[GroupType.GROUP] || [];
                let ancestorsUuids = props.getGenerationUuids(props.group.uuid);
                let newArr = Array.from(new Set([...oldArr, ...ancestorsUuids]))
                entity.group[GroupType.GROUP] = newArr;
                modifyPris.push(entity);
            } else if (opeType === 'remove') {
                let entity = editor.entityDict[model.uuid];
                let newArr = (entity.group[GroupType.GROUP] || [])?.filter(g => g !== props.group?.uuid);
                entity.group[GroupType.GROUP] = newArr;
                modifyPris.push(entity);
            }
        })
        editor.listeners.signals.emptySelectedEntities.dispatch();
        TnMessage.success("编辑成功");
        setGrouping(false);
        setOpeType(null);
        new AddPrimitivesCommand(modifyPris).execute();
        // let oldPris = editor.getEntities()?.filter(item => item?.group[GroupType.GROUP]?.some(guid => guid === props.group.uuid))?.map(i => i.uuid) || [];
        // let newPris = selected?.map(item => item.uuid) || [];
        // // 需要新增
        // const toAddPriUuids = newPris?.filter(pid => !oldPris?.includes(pid));
        // // 需要删除
        // const toRemovePriUuids = oldPris?.filter(pid => !newPris?.includes(pid));
        // // 变更的图元
        // let modifyPris = [];
        // if (toAddPriUuids) {
        //     for (let item of toAddPriUuids) {
        //         let entity = editor.entityDict[item];
        //         if (!entity?.group) {
        //             entity.group = {};
        //         }
        //         let oldArr = entity.group[GroupType.GROUP] || [];
        //         let ancestorsUuids = props.getGenerationUuids(props.group.uuid);
        //         let newArr = Array.from(new Set([...oldArr, ...ancestorsUuids]))
        //         entity.group[GroupType.GROUP] = newArr;
        //         modifyPris.push(entity);
        //     }
        // }
        // if (toRemovePriUuids) {
        //     for (let item of toRemovePriUuids) {
        //         let entity = editor.entityDict[item];
        //         let newArr = (entity.group[GroupType.GROUP] || [])?.filter(g => g !== props.group?.uuid);
        //         entity.group[GroupType.GROUP] = newArr;
        //         modifyPris.push(entity);
        //     }
        // }
        // editor.listeners.signals.emptySelectedEntities.dispatch();
        // TnMessage.success("编辑成功");
        // setGrouping(false);
        // setOpeType(null);
        // new AddPrimitivesCommand(modifyPris).execute();
    }


    const toggleHidden = (targetHidden: boolean) => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        let editor = graphicStore?.extraContext?.getCurrentViewEditor();
        let primitives = []
        let entities = editor.getEntities()
        for(let i = 0; i < entities?.length; i++) {
            let item = entities[i]
            if(!item?.group){
                item.group = {}
            }
            if(!item.group[GroupType.GROUP]){
                item.group[GroupType.GROUP] = []
            }
            if(item.group[GroupType.GROUP].some(guid => guid === props.group.uuid)){
                primitives.push(item)
            }
        }
        // let primitives = editor.getEntities()?.filter(item => item?.group[GroupType.GROUP]?.some(guid => guid === props.group.uuid)) || [];

        for (let pri of primitives) {
            let entity = editor.entityDict[pri.uuid];
            entity.hidden = targetHidden;
            entity.needRedraw = true;
        }

        editor.selectControl.resetSelectedEntities();
        editor.listeners.signals.needRender.dispatch('redraw');
        props.onUpdate({
            ...props.group,
            hidden: targetHidden,
        })
    }

    const showAndSelectModels = () => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        let editor = graphicStore?.extraContext?.getCurrentViewEditor();
        let primitives = editor.getEntities()?.filter(item => item?.group[GroupType.GROUP]?.some(guid => guid === props.group.uuid)) || [];
        showEntity(primitives);
        editor.selectControl.resetSelectedEntities();
        editor.selectControl.forceEntitiesSelected(primitives);
        editor.listeners.signals.needRender.dispatch('redraw');
    }

    return (
        <>
            <div className={classNames({
                'group-item': true,
                'group-item-active': props.active,
            })}
                onContextMenu={(e) => {
                    e.preventDefault();
                    onRightClick(e)
                }}
                ref={ref}
            >
                {!editing && <>
                    <div className="arrow-group">
                        <div className='arrow'>
                            {props.group?.expand && props.group?.children?.length > 0 && <DownSvg onClick={props.toggleExpand} />}
                            {!props.group?.expand && props.group?.children?.length > 0 && <RightSvg onClick={props.toggleExpand} />}
                        </div>
                        {!grouping && <Tooltip title={props.group?.hidden ? '显示' : '隐藏'} placement='top' arrow={false}>
                            <div className="arrow">
                                {props.group?.hidden && <CloseSvg onClick={() => toggleHidden(false)} />}
                                {!props.group?.hidden && <OpenSvg onClick={() => toggleHidden(true)} />}
                            </div>
                        </Tooltip>}
                    </div>
                    <div className="name"
                        onClick={() => props.onClick(props.group)}
                        onDoubleClick={showAndSelectModels}
                    >{`${props.group?.name || ''}`}</div>
                    <div className='icon-group'>
                        {props.active && !grouping && <Tooltip title='剔除图元' placement='top' arrow={false}>
                            <div className='icon'
                                onClick={() => startGrouping('remove')}
                            ><MoveSvg /></div>
                        </Tooltip>}
                        {props.active && !grouping && <Tooltip title='添加图元' placement='top' arrow={false}>
                            <div className='icon'
                                onClick={() => startGrouping('add')}
                            ><EditSvg /></div>
                        </Tooltip>}
                        {props.active && !grouping && <Tooltip title='更多' placement='top' arrow={false}>
                            <div className='icon'
                                onClick={() => {
                                    if (ref.current) {
                                        const rect = ref.current.getBoundingClientRect();
                                        setTop(rect.bottom + 4);
                                        setLeft(rect.right - 96);
                                        setCmOpen(true);
                                    }
                                }}
                            ><ManySvg /></div>
                        </Tooltip>}
                        {props.active && grouping && <div className='icon'
                            onClick={finishGroup}
                        ><ConfirmSvg /></div>}
                        {props.active && grouping && <div className='icon'
                            onClick={() => {
                                setGrouping(false);
                                graphicStore?.extraContext?.getCurrentViewEditor()?.selectControl?.resetSelectedEntities();
                            }}
                        ><CancelSvg /></div>}
                    </div>
                </>}
                {editing && <TnInput
                    className="small-input"
                    size='small'
                    defaultValue={props.group?.name || ''}
                    onBlur={onUpdate}
                    onEscapeKeyDown={() => {
                        setEditing(false);
                    }}
                    onPressEnter={onUpdate}
                    autoFocus
                />}
            </div>

            {adding && <div className='group-item'>
                <TnInput
                    className="small-input"
                    size='small'
                    defaultValue={''}
                    onBlur={onCreate}
                    onEscapeKeyDown={() => {
                        setAdding(false);
                    }}
                    onPressEnter={onCreate}
                    autoFocus
                />
            </div>}

            <ContextMenuFC
                visible={cmOpen}
                top={top}
                left={left}
                width={96}
                wrapperClassname='tn-right-context-menu'
                onCancel={() => { setCmOpen(false) }}
            >
                <div className="menu-item" onClick={() => { setAdding(true); setCmOpen(false); }}>添加子集</div>
                <div className="menu-item" onClick={() => { setEditing(true); setCmOpen(false); }}>重命名</div>
                <div className="menu-item" onClick={() => { onDelete(); setCmOpen(false); }}>删除</div>
                <div className="menu-item" onClick={() => {
                    if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
                    let editor = graphicStore?.extraContext?.getCurrentViewEditor();
                    Object.keys(editor.entityDict)?.forEach(key => {
                        let entity = editor.entityDict[key];
                        if (entity?.group[GroupType.GROUP]?.some(guid => guid === props.group.uuid)) {
                            entity.hidden = false;
                        } else {
                            entity.hidden = true;
                        }
                        entity.needRedraw = true;
                    })
                    editor.listeners.signals.needRender.dispatch("redraw");
                    props.showOne(props.group.uuid);
                    setCmOpen(false);
                }}>仅显示该组</div>
                <div className="menu-item" onClick={() => {
                    if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
                    graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.onOpeCommandActive.dispatch("AA");
                    props.showAll();
                    setCmOpen(false);
                }}>全部显示</div>
            </ContextMenuFC>
        </>
    )
}